import { RichText } from "@/components/richText/richText.component";

import type { MonitoringPlanSystemDrawerBaseSystem } from "./monitoringPlanSystemDrawerContent.component";

export const BenefitsRichTextList = ({
  benefits,
}: BenefitsRichTextListProps) => {
  return <RichText>{benefits}</RichText>;
};

type BenefitsRichTextListProps = {
  benefits: MonitoringPlanSystemDrawerBaseSystem["benefits"];
};
